import { useMemo, useRef, useState } from 'react';
import classNames from 'classnames';
import { debounce } from 'lodash-es';
import { Typography, Box } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import ExternalLinkButton from "../../../../components/ExternalLinkButton";
import styles from "./UploadContainer.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const GetUploadContainerTID = parentTestId => getTestIds(parentTestId);
export const UploadContainer = _ref => {
  let {
    error,
    uploadFile
  } = _ref;
  const {
    UploadContainerTestIds
  } = useMemo(() => GetUploadContainerTID(), []);
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const debouncedSetIsDragging = debounce(setIsDragging, 100);
  const handleFileSelect = event => {
    const files = event.target.files;
    if (files && files.length > 0) {
      uploadFile(files[0]);
    }
  };
  const handleClickUpload = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  const handleDragOver = event => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(true);
    debouncedSetIsDragging(true);
  };
  const handleDragLeave = event => {
    event.preventDefault();
    event.stopPropagation();
    debouncedSetIsDragging(false);
  };
  const handleDrop = event => {
    event.preventDefault();
    debouncedSetIsDragging(false);
    const files = event.dataTransfer.files;
    if (files && files.length > 0) {
      uploadFile(files[0]);
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Box, {
      className: styles.uploadContainerWrapper,
      children: [/*#__PURE__*/_jsxs(Box, {
        "data-testid": UploadContainerTestIds.Container(),
        className: classNames(styles.uploadContainer, {
          [styles.error]: !!error
        }),
        onClick: handleClickUpload,
        onDragOver: handleDragOver,
        onDrop: handleDrop,
        onDragLeave: handleDragLeave,
        children: [isDragging && /*#__PURE__*/_jsx(Box, {
          className: classNames(styles.uploadContainerDragging, {
            [styles.display]: isDragging
          }),
          children: /*#__PURE__*/_jsx(Typography, {
            skin: "secondary",
            variant: "h4",
            children: "Drop CSV file here"
          })
        }), /*#__PURE__*/_jsxs(Box, {
          className: styles.uploadContainerContent,
          children: [/*#__PURE__*/_jsx("input", {
            type: "file",
            "data-testid": UploadContainerTestIds.Input(),
            ref: fileInputRef,
            accept: ".csv",
            onChange: handleFileSelect,
            style: {
              display: 'none'
            }
          }), /*#__PURE__*/_jsxs(Box, {
            children: [/*#__PURE__*/_jsx(Typography, {
              as: "span",
              skin: "link",
              children: "Choose a csv file"
            }), ' ', /*#__PURE__*/_jsx(Typography, {
              as: "span",
              skin: "secondary",
              children: "to upload a list of line items."
            })]
          })]
        })]
      }), error && /*#__PURE__*/_jsx(Typography, {
        skin: "error",
        "data-testid": UploadContainerTestIds.Error(),
        children: error
      })]
    }), /*#__PURE__*/_jsx(Box, {
      className: styles.downloadExample,
      children: /*#__PURE__*/_jsx(ExternalLinkButton, {
        "data-testid": UploadContainerTestIds.DownloadExample(),
        href: "https://storage.googleapis.com/anchor-statics/Anchor_Bulk_Bill/2025-06-18/Anchor_Bulk_Bill.zip",
        className: styles.downloadLink,
        children: "Download example file"
      })
    })]
  });
};